import React, { useState, useRef, useEffect } from "react";
import { useRouteError } from "react-router-dom";
import { IMG_LOGO, IMG_FOUR_O_FOUR, IMG_MOON, IMG_ARROW } from "../../config";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import "../../index.css";
import "./ErrorPage.css";

import config from "environment";
import { selectUser } from "../../redux/features/appData";

export default function ErrorPage() {
  const navigate = useNavigate();
  const userId = useSelector(selectUser)?.id;

  const [isReadOnly, setIsReadOnly] = useState<boolean>(false);

  const error = useRouteError() as any;
  console.error(error);

  useEffect(() => {
    if (userId) {
      // setIsReadOnly(false);
    }
  }, []);

  const handleHome = () => {
    if (isReadOnly) {
      window.location.href = "https://usewinslow.com";
      return;
    }

    navigate("/");
  };

  return (
    <div id="error-page" className={config.theme}>
      <div className="error-page-header">
        <a href="https://usewinslow.com">
          <div className="error-page-logo">
            <img src={IMG_LOGO} style={{ width: "40px", height: "40px" }} />
            <span className="error-page-company-name">Winslow</span>
          </div>
        </a>

        <div className="error-page-signup">
          {isReadOnly && (
            <>
              <button
                onClick={() => {
                  navigate("/login");
                }}
                style={{ backgroundColor: "var(--button-color-secondary)" }}>
                Sign In
              </button>
              <button
                onClick={() => {
                  navigate("/signup");
                }}>
                Sign Up for Free
              </button>
            </>
          )}
        </div>
      </div>

      <div className="error-page-body">
        <img src={IMG_FOUR_O_FOUR} className="error-page-body-404" />
        <div className="error-page-text">
          The page you are looking for is lost in space.
          <br />
          You don’t have to be, just go home.
        </div>
        <button onClick={handleHome}>Go Home</button>

        <div className="error-page-body-arrow">
          <img src={IMG_ARROW} />
        </div>
      </div>

      <div className="error-page-error">
        {error.statusText || error.message}
      </div>

      <div className="error-page-moon">
        <img src={IMG_MOON} style={{ height: "400px" }} />
      </div>
    </div>
  );
}
